export const LOCAL_STORAGE_KEY_SORTER = 'products-sorter'
export const LOCAL_STORAGE_KEY_PAGE_LIMIT = 'table-products-pageLimit'

export const HOTJAR_EVENT_CURRENCY_SURVEY = 'currency_survey'
